import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { useNoSSRBreakpointValue as u } from "../../hooks/useNoSSRBreakpointValue.es.js";
import { Button as i, IconButton as f } from "../../atoms/Button/Button.es.js";
import { useMultiStyleConfig as I, useColorModeValue as g, chakra as S } from "@chakra-ui/react";
import { FloatingActionWrapper as n } from "./FloatingActionWrapper.es.js";
import { DownloadIcon as z, ShareIcon as B, PlusIcon as M, TrashIcon as d } from "../../icons/index.es.js";
const b = ({
  primary: c = {},
  remove: t,
  secondary: l,
  tertiary: r,
  selectAll: e,
  ...s
}) => {
  const h = u({ base: !0, md: !1 }), a = I("FloatingBottomMultiselectActions"), p = g("light", "dark");
  return /* @__PURE__ */ m(S.div, { __css: a.actionsContainer, ...s, children: [
    e && /* @__PURE__ */ o(n, { tooltip: e.tooltip, children: /* @__PURE__ */ o(
      i,
      {
        __css: a.actionsContainerSelectAll,
        variant: "transparent",
        ...e,
        size: "md",
        children: e.children ?? "Select all"
      }
    ) }),
    r && /* @__PURE__ */ o(n, { tooltip: r.tooltip, children: /* @__PURE__ */ o(i, { variant: "tertiary", leftIcon: /* @__PURE__ */ o(z, {}), ...r, size: "md", children: r.children ?? "Download" }) }),
    l && /* @__PURE__ */ o(n, { tooltip: l.tooltip, children: /* @__PURE__ */ o(i, { variant: "tertiary", leftIcon: /* @__PURE__ */ o(B, {}), ...l, size: "md", children: l.children ?? "Share" }) }),
    /* @__PURE__ */ o(n, { tooltip: c.tooltip, children: /* @__PURE__ */ o(
      i,
      {
        variant: p === "dark" ? "secondary" : "primary",
        leftIcon: /* @__PURE__ */ o(M, {}),
        ...c,
        size: "md",
        children: c.children ?? "Add to"
      }
    ) }),
    t && /* @__PURE__ */ o(n, { tooltip: t.tooltip, children: h ? /* @__PURE__ */ o(i, { variant: "danger", leftIcon: /* @__PURE__ */ o(d, {}), ...t, size: "md", children: t.children ?? "Remove" }) : /* @__PURE__ */ o(f, { variant: "danger", icon: /* @__PURE__ */ o(d, {}), ...t, size: "md" }) })
  ] });
};
export {
  b as FloatingBottomMultiselectActions
};
//# sourceMappingURL=FloatingBottomMultiselectActions.es.js.map
